import { useRouteMatch } from 'react-router-dom'

function useIsAdminRoute() {
  const { url } = useRouteMatch()
  return url.split('/').includes('admin')
}

export { useIsAdminRoute }
